
import { configureStore } from '@reduxjs/toolkit';

import authSlice from './slices/AuthSlice';
import turnoSlice from './slices/TurnoSlice';
import loadingSlice from './slices/LoadingSlice';
import recepcionSlice from './slices/RecepcionSlice';
import ubicacionSlice from './slices/UbicacionSlice';
import bandejaSlice from './slices/BandejaReducer';
import snackbarSlice from './slices/SnackbarSlice';

const store = configureStore({
    reducer: {
        auth:       authSlice,
        turno:      turnoSlice,
        loading:    loadingSlice,
        recepcion:  recepcionSlice,
        ubicacion:  ubicacionSlice,
        bandeja:    bandejaSlice,
        snackbar:   snackbarSlice
    },
});

export type RootState = ReturnType<typeof store.getState>

export default store